import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=08d37e06&scoped=true&"
import script from "./Node.vue?vue&type=script&lang=ts&"
export * from "./Node.vue?vue&type=script&lang=ts&"
import style0 from "./Node.vue?vue&type=style&index=0&id=08d37e06&prod&lang=scss&scoped=true&"
import style1 from "./Node.vue?vue&type=style&index=1&id=08d37e06&prod&lang=scss&"
import style2 from "./Node.vue?vue&type=style&index=2&id=08d37e06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d37e06",
  null
  
)

export default component.exports